import { PortalJourney } from "./portal-journey";
import { PortalShell } from "./portal-shell";

export default function PortalRouter() {
  return (
    <PortalShell>
      <PortalJourney />
    </PortalShell>
  );
}
